module.exports = __webpack_public_path__ + "nc_static/media/userManagement.e859df55.svg";